import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
  SplitOptions,
  SplitService,
  SplitterDirectionEnum,
  SplitterUnitEnum
} from '@mydocma/component-library/src/lib/split';
import {CreationService} from '../creation-service/creation-service';
import {PinCreationState} from '../creation-service/pin-creation-state-enum';
import {ObjectSelectionService} from '../location-services/object-selection.service';
import {MydocmaPromptButtonTypeEnum, PromptDialogService} from '@mydocma/component-library/src/lib/prompt-dialog';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {MmBimService} from '../../mm-bim.service';
import {PlanViewerService} from '../plan-viewer/plan-viewer.service';
import {LocationService} from '../location-services/location.service';
import {PlanLocationService} from '../location-services/plan-location.service';
import {PinService} from '../pin-service/pin-service';
import {MmFaultsViewService} from '../../../mm-faults/mm-faults-view/services/mm-faults-view.service';
import {
  CoordinatesTransformationService
} from '../coordinates-transformation-service/coordinates-transformation.service';
import {ViewerService} from '../viewer.service';
import {MmBimViewerService} from '../bim-viewer/mm-bim-viewer.service';
import {MmFilterService} from '../../../mm-filter/mm-filter.service';
import {filter, firstValueFrom, merge, Subject} from 'rxjs';
import {FaultData} from '@docma-mm-core/fault/fault-data';
import {Structure} from '@docma-mm-core/structure/structure';
import {ViewFault} from '@docma-mm-core/fault/fault';
import {FaultService} from '@docma-mm-core/fault/fault.service';
import {AttachmentService} from '@docma-mm-core/attachment/attachment.service';
import {AttachmentType} from '@docma-mm-core/attachment/attachment-type';
import {MmFaultsLoaderService} from '../../../mm-faults/mm-faults-loader.service';
import {NotificationService} from '@mydocma/component-library/src/lib/notification';
import {FieldDefaultNameEnum} from '@docma-mm-core/field/field-default-name.enum';
import {AppRightPaneService, PendingService} from '@mydocma/app-container';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {BimNotificationService} from '../helpers/bim-notification.service';
import {TranslateService} from '@ngx-translate/core';
import {MmBimDialogService} from './bim-dialog.service';
import {debounceTime, first} from "rxjs/operators";
import {BpPin} from '../../../bp-common/models/bp-pin';
import {MmProjectPermissionsService} from '../../../mm-project/mm-project-permissions-service';
import {ProjectActionPermissionEnum} from '@docma-mm-core/permission/project-action-permission.enum';
import { ScreenOrientationService } from '@mydocma/core';
import { DeviceService } from '@mydocma/core/src/lib/device';
import { getPlanSectionIndexForFault } from '../../../mm-faults/mm-plans-view/services/mm-plan-section-utils';
import { getTranslatedFilenameForNewPlanSection } from '@mydocma/component-library';
import { MmPlansManagerService } from '../../../mm-faults/mm-plans-view/services/mm-plans-manager.service';

@UntilDestroy()
@Component({
  selector: 'mydocma-mm-bim-dialog',
  templateUrl: './bim-dialog.component.html',
  styleUrls: ['./bim-dialog.component.scss'],
  providers: [
    ViewerService,
    MmBimViewerService,
    PlanLocationService,
    CreationService,
    PinService,
    ObjectSelectionService,
    LocationService,
    PlanViewerService,
    CoordinatesTransformationService,
    BimNotificationService,
  ]
})
export class MmBimDialogComponent implements OnInit, AfterViewInit {
  public pinCreationState = PinCreationState;

  public splitOptions: SplitOptions = {direction: SplitterDirectionEnum.Vertical };
  splitterDirectionEnum = SplitterDirectionEnum;
  mainSplitAreaService: SplitService;
  containerSplitAreaService: SplitService;
  containerSplitAreaWidth: number;

  currentPlanListSize: number;

  public creationState: PinCreationState;
  public creationStateEnum = PinCreationState;
  planListSideAreaOptions: SplitOptions = {
    direction: SplitterDirectionEnum.Horizontal,

  };
  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('element', {static: false}) element: ElementRef;
  collapsable = false;
  public startInCreationMode = false;
  public laoderVisibility = false;
  permissionNewFault$ = this.permissionService.hasProjectActionPermissions([ProjectActionPermissionEnum.NewFault]);
  private resizeContainerSubject = new Subject();
  private resizeMainSubject = new Subject();

  constructor(
    public mmBimService: MmBimService,
    private objectSelectionService: ObjectSelectionService,
    private readonly promptService: PromptDialogService,
    private readonly faultsViewService: MmFaultsViewService,
    private viewerService: ViewerService,
    private readonly filterService: MmFilterService,
    private readonly faultService: FaultService,
    private readonly faultsLoaderService: MmFaultsLoaderService,
    private readonly notficationService: NotificationService,
    private readonly attachmentService: AttachmentService,
    private readonly appRightPaneService: AppRightPaneService,
    private readonly pendingService: PendingService,
    public pinService: PinService,
    public planViewerService: PlanViewerService,
    public creationService: CreationService,
    public bimNotificationService: BimNotificationService,
    private translateService: TranslateService,
    private dialogService: MmBimDialogService,
    private readonly permissionService: MmProjectPermissionsService,
    public readonly screenOrientationService: ScreenOrientationService,
    public readonly deviceService: DeviceService,
    private readonly plansManagerService: MmPlansManagerService
  ) {
  }

  ngOnInit(): void {

    // this.faultsViewService.setCurrentFault(null);
    // this.pinService.selectPin(null);

    this.creationService.pinCreationState$.pipe(untilDestroyed(this)).subscribe(value => {
      if(this.containerSplitAreaService && this.containerSplitAreaService.areaItems.length == 2) {
        this.currentPlanListSize = this.containerSplitAreaService.areaItems[0].size;
      }
      this.creationState = value;
    });

    if (this.startInCreationMode) {
      this.creationService.startPinCreation({hideExistingPins: true, pendPlanSelection: true});
    }

    this.faultsViewService.currentFault.pipe(untilDestroyed(this)).subscribe((fault) => {
      if(fault && fault.bpPin) {
        this.pinService.selectPin(fault.bpPin.ExternalId);
      }
    })

  }

  ngAfterViewInit() {


  }

  async editFault() {
    const fault: ViewFault = (await firstValueFrom(this.pinService.selectedPin$)).bimPin.data;
    await this.editFaultFromPin(fault as ViewFault);

    const result = await firstValueFrom(fault.changeState$.pipe(filter(s => s.status === ChangeStatusEnum.Changed)));

    if (result) {
      this.faultsViewService.closeRightPane();
    }
  }

  toggleSplitterDirection(direction: SplitterDirectionEnum) {
    const minSizeModel = this.deviceService.isTablet() ? 200 : 300;
    const minSizePlan = this.deviceService.isTablet() ? 175 : 160;
    this.splitOptions.direction = direction;

    if(!this.mainSplitAreaService) return;

    if(this.splitOptions.direction === SplitterDirectionEnum.Vertical) {
      this.splitOptions.unit = SplitterUnitEnum.Percent;
      const mainHeight = this.element.nativeElement.clientHeight;
      if(this.mainSplitAreaService?.areaItems?.length === 2) {

        setTimeout(() => {
          this.mainSplitAreaService.areaItems[0].size = 55;
          this.mainSplitAreaService.areaItems[0].minSize = (minSizeModel / mainHeight) * 100;
          this.mainSplitAreaService.areaItems[0].maxSize = null;

          this.mainSplitAreaService.areaItems[1].size = 45;
          this.mainSplitAreaService.areaItems[1].minSize = (minSizePlan / mainHeight) * 100;
          this.mainSplitAreaService.areaItems[1].maxSize = null;

        }, 10);
      }
    } else {
      this.splitOptions.unit = SplitterUnitEnum.Pixel;
      const mainWidth = this.element.nativeElement.clientWidth;
      if(this.mainSplitAreaService?.areaItems?.length === 2) {
        this.mainSplitAreaService.areaItems[1].minSize = minSizePlan;
        this.mainSplitAreaService.areaItems[1].maxSize = mainWidth - minSizeModel;
        setTimeout(() => this.mainSplitAreaService.setAreaSizes(['*', 0.45 * mainWidth]), 10);
      }
    }

  }

  async nextFaultCreation() {
    if (this.creationService.creationState === PinCreationState.ObjectSelected) {

      this.creationService.startSnapshotMode();
    } else {
      let snaphotResult: { bimSnapshot: Blob, planSnapshot: Blob };
      try {
        this.showLoader();
        snaphotResult = await this.creationService.getSnapshots();
      } catch (ex) {
        this.notficationService.error('An error while creating snapshoots');
        return;
      } finally {
        this.hideLoader();
      }

      const pin = await this.creationService.getPin();

      const dialogResult = await this.createFaultFromPin(pin, snaphotResult.planSnapshot, snaphotResult.bimSnapshot);
      if (dialogResult) {
        this.creationService.endPinCreation({endWithPin: true});
      }
    }
  }

  async closeDialog() {
    if (this.creationService.creationState === PinCreationState.ObjectSelected || this.creationService.creationState === PinCreationState.PrepareSave) {
      const cancelPromptData = this.cancelCreationPromptData();
      const result = await this.promptService.showPromptDialog(cancelPromptData);
      if (!result.value) {
        return;
      }
    }

    const currentPin = await this.pinService.selectedPin$.pipe(first()).toPromise();
    await this.faultsViewService.setCurrentFault(currentPin?.bimPin?.data ?? null);

    this.faultsViewService.closeRightPane();
    this.dialogService.closeBimDialog();
  }

  async createFaultFromPin(pin: BpPin, planSection: Blob, bimSection: Blob): Promise<ViewFault> {
    let fault: ViewFault;
    const filterState = await firstValueFrom(this.filterService.state);
    const project = filterState?.project;
    if (!project) {
      throw new Error(`Can't create a new fault. No project is selected.`);
    }

    try {
      const faultData = new FaultData();
      faultData.Pin = pin;
      faultData.CreatedOn = new Date(Date.now());
      if (filterState.structure && filterState.structure.Id) {
        faultData.Structure = new Structure({Id: filterState.structure.Id});
      } else {
        faultData.Structure = new Structure({Id: project.Structure.Id});
      }

      fault = new ViewFault(await this.faultService.createNewFault(project.MyDocmaUid, faultData));
      fault.unsavedNew = true;

      fault.project = project;

      const planSectionIndex = getPlanSectionIndexForFault(fault);
      const plan = this.plansManagerService.selectedPlan.data.FileName;
      const fileName = getTranslatedFilenameForNewPlanSection(plan, planSectionIndex, this.translateService, false);
      const fileDescription = getTranslatedFilenameForNewPlanSection(plan, planSectionIndex, this.translateService, true);

      let attachment = this.attachmentService.createNewAttachment({Description: fileDescription},
        new File([planSection], fileName, {type: 'image/jpeg'}),
        AttachmentType.PlanSection);
      fault.addAttachment(attachment);

      const bimSectionIndex = 1;
      const bimSectionDescription = this.translateService.instant('MM.bimViewer.modelSection') + ' ' + bimSectionIndex;
      const bimSectionFilename = bimSectionDescription.replaceAll(' ', '_');


      attachment = this.attachmentService.createNewAttachment(
        {Description: bimSectionDescription, CreatedOn: fault.data.CreatedOn},
        new File([bimSection], bimSectionFilename, {type: 'image/jpeg'}),
        AttachmentType.Picture);
      fault.addAttachment(attachment);

      this.faultsLoaderService.addFault(fault);
    } catch (ex) {
      this.notficationService.error('Can not create a new fault');
    }
    await this.faultsViewService.openRightPane(fault, 0, FieldDefaultNameEnum.Description1, true);

    const result = await firstValueFrom(merge(
      this.appRightPaneService.isOpen.pipe(filter(o => !o)),
      fault.changeState$.pipe(filter(s => s.status === ChangeStatusEnum.NotChanged))
    ));

    if (result) {
      this.faultsViewService.closeRightPane();
    }
    return result ? fault : null;
  }

  async editFaultFromPin(fault: ViewFault) {
    this.faultsViewService.openRightPane(fault, 0, FieldDefaultNameEnum.Description1, true);
  }

  async startFaultCreation() {
    if (!this.mmBimService.selectedPlan) {
      this.planViewerService.setNoPlanSelectedHintBlink();
      return;
    }

    const selectedPin = this.objectSelectionService.selectedObject;
    if (selectedPin) {
      const promptData = this.confirmationPromptData();
      const result = await this.promptService.showPromptDialog(promptData);
      if (result?.value) {
        this.creationService.startPinCreation({hideExistingPins: true, skipObjectSelected: true}, selectedPin);
      }
      return;
    }
    this.creationService.startPinCreation({hideExistingPins: true});
  }

  public async cancelPrepareSave() {
    if (
      this.creationService.creationState === PinCreationState.ObjectSelected
      || this.creationService.creationState === PinCreationState.PrepareSave
    ) {
      const cancelPromptData = this.cancelCreationPromptData();
      const result = await this.promptService.showPromptDialog(cancelPromptData);
      if (result?.value) {
        this.creationService.cancelCreation(result?.value);
      }
      return;

    }
    this.creationService.cancelCreation();
  }

  back() {
    this.creationService.cancelPrepareSave();
  }

  updateMinSizeMainContainer() {

  }

  resizeMain(elem: HTMLDivElement) {
    this.resizeMainSubject.next(elem);
  }

  resizeContainer(element: HTMLDivElement) {
    this.resizeContainerSubject.next(element);
  }

  // listen container of related to it split, calc min size depending on container width
  public splitReady($event: SplitService) {
    this.containerSplitAreaService = $event;
    const width = this.container.nativeElement.getBoundingClientRect().width;
    const defaultPlanlistSize = this.deviceService.isTablet() ? 255 : 300;
    const minSizeMainArea = this.deviceService.isTablet() ? 210 : 255;
    const size = (defaultPlanlistSize / width) * 100;
    setTimeout(() => {
      $event.setAreaSizes([size, 100 - size]);
    });
    this.resizeContainerSubject.pipe(untilDestroyed(this), debounceTime(50)).subscribe((elem: HTMLDivElement) => {
      const value = elem.getBoundingClientRect()?.width;
      if ($event.areaItems && $event.areaItems[0]) {
        $event.areaItems[0].minSize = (minSizeMainArea / value) * 100;
      }
      if ($event.areaItems && $event.areaItems[1]) {
        $event.areaItems[1].minSize = (1000 / value) * 100;
      }

    });
  }

  // 300 and 160  are the min splitter sized
  public mainSplitAreaReady($event: SplitService): void {
    this.mainSplitAreaService = $event;
    let initSizes = true;
    this.resizeMainSubject.pipe(untilDestroyed(this), debounceTime(50)).subscribe((elem: HTMLDivElement) => {
      if ($event.areaItems?.length === 2 && initSizes) {
        initSizes = false;
        if (this.splitOptions.direction === SplitterDirectionEnum.Vertical) {
          setTimeout(() => {
            $event.setAreaSizes([55, 45]);
          });
        } else {
          setTimeout(() => {
            const width = this.element.nativeElement.getBoundingClientRect().width;
            const size = 0.45 * width;
            $event.setAreaSizes(['*', size]);
          });
        }
      }

      const minSizeModel = this.deviceService.isTablet() ? 200 : 300;
      const minSizePlan = this.deviceService.isTablet() ? 175 : 160;
      if (this.splitOptions.direction === SplitterDirectionEnum.Vertical) {
        const height = elem.getBoundingClientRect()?.height;
        if ($event.areaItems && $event.areaItems[0]) {
          $event.areaItems[0].minSize = (minSizeModel / height) * 100;
        }
        if ($event.areaItems && $event.areaItems[1]) {
          $event.areaItems[1].minSize = (minSizePlan / height) * 100;
        }
      } else {
        const width = elem.getBoundingClientRect()?.width;
        if ($event.areaItems && $event.areaItems[0]) {
          $event.areaItems[1].minSize = minSizePlan;
          const modelViewWidth = document.getElementsByClassName('bim-viewer-split-area')[0]?.clientWidth;
          let offsetSplitter = 0;
          if (modelViewWidth < minSizeModel) {
            offsetSplitter = minSizeModel - modelViewWidth;
          }

          $event.areaItems[1].maxSize = width - minSizeModel - offsetSplitter;
          setTimeout(() => $event.areaItems[1].size -= offsetSplitter, 5);

        }
      }
    });
  }

  // listen container of related to it split, calc min size depending on container height


  private showLoader() {
    this.laoderVisibility = true;
  }

  private hideLoader() {
    this.laoderVisibility = false;
  }

  private confirmationPromptData() {
    return {
      title: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.title'),
      subTitle: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.subTitle'),
      content: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.content'),
      buttons: [{
        text: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.no'),
        type: MydocmaPromptButtonTypeEnum.default,
        value: false
      }, {
        text: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.yes'),
        type: MydocmaPromptButtonTypeEnum.primary,
        value: true
      }]
    };
  }

  private cancelCreationPromptData() {
    return {
      title: this.translateService.instant('MM.bimViewer.cancelCreationDialogDialog.title'), // Discard changes
      content: this.translateService.instant('MM.bimViewer.cancelCreationDialogDialog.content'),
      buttons: [{
        text: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.no'),
        type: MydocmaPromptButtonTypeEnum.default,
        value: false
      }, {
        text: this.translateService.instant('MM.bimViewer.objectSelectionConfirmationDialog.yes'),
        type: MydocmaPromptButtonTypeEnum.primary,
        value: true
      }]
    };
  }
}
